import React, { useEffect, useState } from 'react';
import { useAuthState } from 'react-firebase-hooks/auth';
import { useSelector } from 'react-redux';
import { Navigate, Outlet } from 'react-router-dom';
import { toast } from 'react-toastify';
import _ from 'lodash';

import { auth } from 'src/app/database';

import { LoaderWrapper, LogoLoader } from 'src/components';

import { ROUTE } from 'src/constants/routes';
import { getUserClaimsSelector } from 'src/store/app';

export const ProtectedBrokerRoute = () => {
  const storedClaims = useSelector(getUserClaimsSelector);

  const [customClaims, setCustomClaims] = useState();

  const [firebaseUser, loadingFirebaseUser] = useAuthState(auth, {
    onUserChanged: async (user) => {
      if (_.isEmpty(storedClaims)) {
        const response = await user.getIdTokenResult();

        setCustomClaims(response?.claims);
      }
    },
  });

  useEffect(() => {
    if (!_.isEmpty(storedClaims)) {
      setCustomClaims(storedClaims);
    }
  }, [storedClaims]);

  useEffect(() => {
    if (!_.isEmpty(customClaims)) {
      if (customClaims?.user_type !== 'broker') {
        toast('You don`t have access to this page', { type: 'error' });
      }
    }
  }, [customClaims]);

  return loadingFirebaseUser ? (
    <LoaderWrapper>
      <LogoLoader />
    </LoaderWrapper>
  ) : firebaseUser &&
    (customClaims?.user_type === 'broker' || storedClaims?.user_type === 'broker') ? (
    <Outlet />
  ) : (
    <Navigate to={ROUTE.LOGIN} />
  );
};
